import { getPrimaryColor } from "utils/themeConfig";

import CustomLink from "../elements/custom-link";
import NextImage from "../elements/image";

import styles from "@/styles/cards.module.scss";

const MediumTeasers = ({ data }) => {
  const arrow = (
    <svg
      className="inline-block"
      width="8"
      height="11"
      viewBox="0 0 8 11"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.41785 10.0002L5.91532 5.49747L1.41785 1"
        stroke={getPrimaryColor()}
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  );
  return (
    <div className="max-w-screen-2xl text-left p-10">
      <h1 className={styles.mainTitle}>{data.title}</h1>
      <h5 className={styles.mainSubTitle}>{data.subTitle}</h5>
      <div className=" my-5 grid grid-cols-1 md:grid-cols-2 text-left gap-5">
        {data.cards.map((v, i) => (
          <div className={`flex flex-row`} key={i}>
            {v.image.data === null ? null : (
              <div className="w-full h-full">
                <NextImage media={v.image.data} />
              </div>
            )}
            <div className="flex flex-col">
              <h5 className={`px-5 mt-0 md:mt-4 ${styles.cardTitleLarge}`}>
                {v.title}
              </h5>
              <small className={`px-5 ${styles.smallText}`}>{v.subTitle}</small>
              <p className={`grow px-5 ${styles.cardDescriptionLarge}`}>
                {v.description}
              </p>
              <p className="text-onmoPrimary mt-1 md:mt-5 px-5 mb-4">
                <CustomLink link={v.link}>
                  <span
                    className={`underline underline-offset-2 ${styles.linkLarge}`}
                  >
                    {v.link.text}
                  </span>{" "}
                  {arrow}
                </CustomLink>
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default MediumTeasers;
